<template>
  <div>
    <div class="card">
      <!---流标处理--->
      <div class="section">
        <div class="section-title">
          <base-section-title title="流标处理" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="auctionInfo"
            :option="options"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:content>
              <u-editor disabled :value="auctionInfo.noticeContent" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'

import { noticeReleaseStatusDict, flowMarkDict } from '@/dictionary/project/common'
import { competeWhetherAnnouncementDict } from '@/dictionary/project/compete'

// api接口
import { getCompeteAbnormalMesApi } from '@/api/procure/compete'

export default {
  components: {
    BaseSectionTitle,
    UEditor
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      auctionInfo: {},
      options: [
        {
          label: '发布流标公告',
          prop: 'closePublicity',
          filter: value => competeWhetherAnnouncementDict.translate(value).label
        },
        {
          label: '流标原因',
          prop: 'closeReason',
          filter: value => flowMarkDict.translate(value).label
        },
        {
          label: '其他原因',
          prop: 'otherReason',
          hideFun: () => this.auctionInfo?.closeReason !== flowMarkDict.OTHER.value
        },
        {
          label: '发布日期',
          prop: 'publishTime',
          isNormDay: true
        },
        {
          label: '发布状态',
          prop: 'releaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '公告标题',
          prop: 'noticeTitle'
        },
        {
          label: '公告内容',
          prop: 'noticeContent',
          slotName: 'content'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler: function(val) {
        if (val) {
          this.getLatestAuction()
        }
      },
      immediate: true
    }
  },

  methods: {
    // 获取流标处理信息
    getLatestAuction() {
      if (!this.orderId) return
      getCompeteAbnormalMesApi(this.orderId)
        .then(res => {
          const { notice, ...other } = res.data || {}
          this.auctionInfo = {
            ...notice,
            ...other
          }
          this.$emit('setAuctionInfo', this.auctionInfo)
        })
        .catch(err => {
          this.$message.error(err.message || '获取信息失败')
        })
    },
  }
}
</script>
